import { CircularProgressbar } from 'react-circular-progressbar';
import "react-circular-progressbar/dist/styles.css";
import apiService from '../../../services/apiService';
import { useEffect, useState, useRef, useContext } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import CustomToast from '../../Toast';
import Loader from '../../layouts/loader';
import Loader2 from '../../layouts/loader2';
import Modal from 'react-modal';
import GeneralModal from '../modal/generalModal';
// import { LanguageContext } from '../../shared/languageContext';
import LanguageSelectModal from '../modal/languageSelectModal';
import { useTranslation } from 'react-i18next';
import Sidebar from '../../layouts/sidebar';

const Course = ({ course }) => {
    const percentage = 0;
    const [courseList, setCourseList] = useState([]);
    const [loader, setLoader] = useState(false);
    const [loading, setLoading] = useState(false);
    const [userInfo, setUserInfo] = useState({})
    const [showFullDescription, setShowFullDescription] = useState({});
    const navigate = useNavigate();
    const [playing, setPlaying] = useState(false);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [videoSrc, setVideoSrc] = useState('');
    // const { selectedLanguages } = useContext(LanguageContext);
    const videoRefs = useRef({});
    const limit = 300;
    const [isOpenLangModal, setIsOpenLangModal] = useState(false)
    const [langSpecific, setLangSpecific] = useState(false)
    const [currentCourse, setCurrentCourse] = useState(false)
    const [fromCourseInfo, setFromCourseInfo] = useState(false)
    const [popUpMessage, setPopUpMessage] = useState(false)
    const [isOpenGenModal, setIsOpenGenModal] = useState(false)
    const [localLangJSON, setLocalLangJSON] = useState(false)
    const [languageSelected, setLanguageSelected] = useState(false) // Track if language was actually selected
    const currentLang = localStorage.getItem('userLang')
    const { t } = useTranslation();
    const { i18n } = useTranslation();
    const [hasClicked, setHasClicked] = useState(false);


    //  console.log("selectedLanguage",  currentLang)

    console.log('i18next', i18n.language);

    const openModal = (videoSrc) => {
        setVideoSrc(videoSrc);
        setModalIsOpen(true);
    };

    const openLanguageSelectModal = (course, value) => {
        getLmsData(userInfo?.uid, course?.new_course_id).then((data) => {
            if (data && value) {
                navigate(`/learning_space/course_details/${course?.course_meta_id}`, { state: { course } });
            } else if (data && !value) {
                startCourseList(course)
            } else if (hasClicked === true) {
                 navigate(`/learning_space/course_details/${course?.course_meta_id}`, { state: { course } });
            } else {
                setCurrentCourse(course)
                setFromCourseInfo(value) // Set this first before any navigation logic
                
                let langStoredData = localStorage.getItem("CourseLanguagesData");

                if (langStoredData) {
                    langStoredData = JSON.parse(langStoredData);
                    console.log("langStoredData: ", langStoredData);
                }
                
                // Always show modal for language selection if more than one language available
                // or if user hasn't completed language selection for this course
                if (langStoredData?.length != 1) {
                    setIsOpenLangModal(true)
                    setLanguageSelected(false) // Reset language selection status
                } else {
                    setIsOpenLangModal(false)
                    setLanguageSelected(true)
                    
                    // Handle single language case - respect the fromCourseInfo flag
                    if (value) { // value is fromCourseInfo parameter
                        navigate(`/learning_space/course_details/${course?.course_meta_id}`, { state: { course } });
                    } else {
                        startCourseList(course);
                    }
                }
            }
        })
    }

    const openGenModal = () => {
        setIsOpenGenModal(true)
    }

    const closeGeneModal = () => {
        setIsOpenGenModal(false)
    }

    const closeLanguageSelectModal = () => {
        setIsOpenLangModal(false)
        // Don't set languageSelected to true here - only set it when user actually selects a language
    }

    const closeModal = () => {
        setModalIsOpen(false);
    };

    const handleViewMore = (courseId) => {
        setShowFullDescription(prevState => ({
            ...prevState,
            [courseId]: !prevState[courseId]
        }));

    };

    useEffect(() => {
        // console.log("selectedLanguage",  selectedLanguages)
        const getCourseData = async () => {
            setLoader(true);
            try {
                let user_details = sessionStorage.getItem('user_details')
                if (user_details) {
                    user_details = JSON.parse(user_details)
                    setUserInfo(user_details)
                }
                const courseResponse = await getCourseList(user_details);
                const initialShowFullDescription = {};
                courseResponse?.data?.course_list?.forEach(course => {
                    initialShowFullDescription[course.course_meta_id] = false;
                });
                setShowFullDescription(initialShowFullDescription);
                setCourseList(courseResponse?.data?.course_list);
                getLMSUserCourse(user_details, courseResponse?.data?.course_list)
            } catch (error) {
                console.error('Error fetching courses:', error);
                // Handle errors as needed
            } finally {
                setLoader(false);
            }
        };
        getCourseData(); // Fetch courses initially

    }, []);

    //   const getLang=async()=>{
    //     const token = apiService.getAuthToken()
    //     try {
    //     const languagesData = await apiService.getLmsv1(`courseLangList/${course?.new_course_id}`, token)
    //     if (languagesData.status) {
    //         setOptions(languagesData.data);
    //     } else {
    //       console.error("Error fetching languages:", languagesData.error);
    //     }
    //   } catch (error) {
    //     console.error("An unexpected error occurred:", error);
    //   }
    // }

    const getCourseSelectedLang = () => {
        let currentCourse
        let localLang = localStorage.getItem('selectedLanguageInfo');
        if (localLang) {
            localLang = JSON.parse(localLang);
            getCourseList(userInfo, localLang.lang_id).then((data) => {
                if (data?.data?.course_list && data?.data.course_list.length > 0) {
                    data.data.course_list = data?.data?.course_list.filter((ele => ele.new_course_id === localLang?.course_id));
                    const updatedCourseList = courseList.map((ele) => {
                        const availableCourse = data?.data.course_list.find(c => c.new_course_id === ele.new_course_id);
                        if (availableCourse) {
                            currentCourse = availableCourse
                            return availableCourse;
                        } else {
                            return ele;
                        }
                    });
                    setCourseList(updatedCourseList);
                    setLangSpecific(true);
                    setLanguageSelected(true); // Mark that language was actually selected
                    if (fromCourseInfo) {
                        navigate(`/learning_space/course_details/${currentCourse?.course_meta_id}`, { state: { currentCourse } });
                    } else {
                        startCourseList(currentCourse)
                    }
                }
            });
        }
    };

    useEffect(() => {
        const initialShowFullDescription = {};
        courseList.forEach(course => {
            initialShowFullDescription[course.course_meta_id] = false;
        });
        setShowFullDescription(initialShowFullDescription);
    }, [langSpecific]);


    const getInitialCall = (course_id, lang, user_details, newCourseList) => {
        let currentCourse
        getCourseList(user_details, lang).then((data) => {
            if (data?.data?.course_list && data?.data?.course_list.length > 0) {
                data.data.course_list = data?.data?.course_list.filter((ele => ele.new_course_id === course_id))
                if (data.data.course_list && data.data.course_list.length > 0) {
                    const updatedCourseList = newCourseList.map((ele) => {
                        const availableCourse = data?.data?.course_list.find(c => c.new_course_id === ele.new_course_id);
                        if (availableCourse) {
                            return availableCourse;
                        } else {
                            return ele;
                        }
                    });
                    setCourseList(updatedCourseList);
                }
                // startCourseList(currentCourse)
            }
        });
    };

    const getLMSUserCourse = async (user_details, courseList) => {
        if (!courseList || courseList?.length === 0) {
            console.error("Empty course list.");
            return;
        }
        const newCourseList = JSON.parse(JSON.stringify(courseList))
        if (courseList && courseList?.length > 0) {
            const allCoursePromises = courseList.map((ele) => {
                return getLmsData(user_details?.uid, ele?.new_course_id);
            });
            try {
                const courseInfo = await Promise.all(allCoursePromises);
                localStorage.setItem('userLangArr', JSON.stringify(courseInfo))
                let count = 0;
                for (let i = 0; i < courseInfo.length; i++) {
                    count++;
                    await getInitialCall(courseInfo[i]?.course_id, courseInfo[i]?.lang_id, user_details, newCourseList);
                    let langId = getLangCode(courseInfo[i]?.lang)
                    i18n.changeLanguage(langId);
                }
                if (count === courseInfo.length) {
                    setLangSpecific(true);
                }
            } catch (error) {
                console.error("An error occurred:", error);
            }
        }
    };

    const getLmsData = (uid, course_id) => {
        return apiService.get(`get-lms-user-course-info?uid=${userInfo?.uid || uid}&course_id=${course_id}`)
            .then((res) => {
                if (res?.status === "success") {
                    return res.data;
                }
                // else {
                //     throw new Error('Failed to fetch data');
                // }
            }).catch((error) => {
                console.log(error);
                CustomToast.info('It seems your connection is slow. Please refresh the page or try again in sometime.');
                return;
            });
    };


    const getCourseList = async (user_details, lang) => {
        try {
            const token = apiService.getAuthToken()
            // let localLang = localStorage.getItem('selectedLanguageInfo');
            // if (localLang) {
            //     localLang = JSON.parse(localLang);
            // }
            const response = await apiService.getLmsv1(`courseCardList?user_id=${user_details?.uid}&lang_id=${lang || ''}`, token);
            return response;
        } catch (error) {
            console.log(error);
            CustomToast.info('It seems your connection is slow. Please refresh the page or try again in sometime.');
            return;
        }
    }

    const getLangCode = (lang) => {
        switch (lang) {
            case 'English':
                return 'en';
            case 'Hindi':
                return 'hi';
            case 'Marathi':
                return 'mar';
            default:
                return 'en';
        }
    };

    const startCourseList = async (data) => {
        setLoader(true);
        try {
            // Set the language info
            let langId = getLangCode(data?.lang);
            i18n.changeLanguage(langId);
            const tForLang = i18n.getFixedT(langId);

            // Check if the course is expired
            if (data?.is_course_expired) {
                setPopUpMessage(tForLang('toast_messages_expired_course_start_error'));
                openGenModal();
            } else {
                // Handle language preference for the user
                let userLangs = localStorage.getItem("userLangArr");
                if (data?.lang) {
                    localStorage.setItem('userLang', data?.lang);
                } else if (userLangs) {
                    userLangs = JSON.parse(userLangs);
                    const fetchData = userLangs.find(ele => ele?.course_id === data?.new_course_id);
                    if (fetchData) {
                        localStorage.setItem('userLang', fetchData?.lang);
                    }
                }

                // Get the auth token
                const token = apiService.getAuthToken();

                // Attempt to start the course
                await apiService.postLmsWithQuery(`startCourse?course_id=${data?.course_id}&user_id=${userInfo?.uid}`, token);

                // Save the course meta ID and navigate
                localStorage.setItem("courseMetaId", data?.course_meta_id);
                navigate(`/learning_space/course_modules/${data?.course_meta_id}`);
                setLoader(false);
            }
        } catch (error) {
            console.log("Error in starting course list:", error);
            setLoader(false);
            CustomToast.info('It seems your connection is slow. Please refresh the page or try again in sometime.');
        }
    };


    const continuesCourse = async (data) => {
        let langId = getLangCode(data?.lang)
        i18n.changeLanguage(langId);
        const tForLang = i18n.getFixedT(langId);
        if (data?.is_course_expired) {
            setPopUpMessage(tForLang('toast_messages_expired_course_start_error'))
            openGenModal()
            // CustomToast.info('The course you are trying to access, has expired. if you need to extend it, please contact your admin.')
        } else {
            let userLangs = localStorage.getItem("userLangArr")
            if (data?.lang) {
                localStorage.setItem('userLang', data?.lang)
                navigate(`/learning_space/course_modules/${data?.course_meta_id}`)
            } else if (userLangs) {
                userLangs = JSON.parse(userLangs)
                const fetchData = userLangs.find(ele => ele.course_id == data?.new_course_id)
                if (fetchData) {
                    localStorage.setItem('userLang', fetchData?.lang)
                }
                navigate(`/learning_space/course_modules/${data?.course_meta_id}`)
            } else {
                navigate(`/learning_space/course_modules/${data?.course_meta_id}`)
            }
        }
    }

    const inProgressCourseList = async (data) => {
        if (data?.is_course_expired) {
            setPopUpMessage('The course you are trying to access, has expired. if you need to extend it, please contact your admin.')
            openGenModal()
        } else {
            let userLangs = sessionStorage.getItem("userLangArr")
            if (data?.lang) {
                localStorage.setItem('userLang', data?.lang)
            } else if (userLangs) {
                userLangs = JSON.parse(userLangs)
                const fetchData = userLangs.find(ele => ele.course_id == data?.new_course_id)
                if (fetchData) {
                    localStorage.setItem('userLang', fetchData?.lang)
                }
            }
            let userDetails = sessionStorage.getItem("userDetail")
            if (userDetails) {
                userDetails = JSON.parse(userDetails)
                userDetails['is_org_user'] = true
                const encodedToken = encodeURIComponent(JSON.stringify(userDetails));
                let url
                if (process.env.REACT_APP_ENV == 'development') {
                    url = `https://fstage-lms.inclusional.com/learning_space/course_modules/${data?.course_meta_id}?ref=${encodedToken}`
                } else {
                    url = `https://fstage-lms.inclusional.com/learning_space/course_modules/${data?.course_meta_id}?ref=${encodedToken}`
                }
                const newTab = window.open(url, '_blank');
                if (newTab) {
                    newTab.focus();
                } else {
                    console.error('Failed to open new tab. Make sure pop-up blocker is disabled.');
                }
            } else {
                window.location.href = process.env.REACT_APP_LOGIN_URL
            }
        }
    }

    const courseInformation = async (data) => {
        let langId = getLangCode(data?.lang)
        i18n.changeLanguage(langId);
        const tForLang = i18n.getFixedT(langId);
        if (data?.is_course_expired) {
            setPopUpMessage(tForLang('toast_messages_expired_course_start_error'))
            openGenModal()
            //   CustomToast.info('The course you are trying to access, has expired. if you need to extend it, please contact your admin.')
        } else {
            let userLangs = localStorage.getItem("userLangArr")
            if (data?.lang) {
                localStorage.setItem('userLang', data?.lang)
                navigate(`/learning_space/course_details/${data?.course_meta_id}`, { state: { course: data } })
            } else if (userLangs) {
                userLangs = JSON.parse(userLangs)
                const fetchData = userLangs.find(ele => ele.course_id == data?.new_course_id)
                if (fetchData) {
                    localStorage.setItem('userLang', fetchData?.lang)
                }
                navigate(`/learning_space/course_details/${data?.course_meta_id}`, { state: { course: data } })
            } else {
                navigate(`/learning_space/course_details/${data?.course_meta_id}`, { state: { course: data } })
            }
        }
    }

    // useEffect(() => {
    //     let user_details = sessionStorage.getItem('user_details')
    //     if (user_details) {
    //         user_details = JSON.parse(user_details)
    //         setUserInfo(user_details)
    //     }
    //     setLoader(true);
    //     getCourseList(user_details).then((data) => {
    //         const initialShowFullDescription = {};
    //         data?.data?.course_list.forEach(course => {
    //             initialShowFullDescription[course.course_meta_id] = false;
    //         });
    //         setShowFullDescription(initialShowFullDescription);
    //         setCourseList(data?.data?.course_list);
    //         setLoader(false);
    //     }).catch((error) => {
    //         setLoader(false);
    //         CustomToast.error(error);
    //     })
    // }, [])

    const selectCourse = (id) => {
        sessionStorage('selectedCourse', id)
    }

    const getCertificate = async (courseDetails) => {
        setLoading(true);
        let user_details = sessionStorage.getItem('user_details')
        let data = {
            "course_id":
                // "432380bf-8bc5-4000-95c1-115f9c8e9d86",
                courseDetails?.course_id,
            "send_email": true,
            "user_id": JSON.parse(user_details)?.uid,
            course_name: courseDetails?.course_name,
            course_lang: courseDetails?.lang
        }
        const token = apiService.getAuthToken()
        await apiService.postV1(`generate-certificate`, data, token).then((data) => {
            if (data?.status) {
                window.open(data?.data?.certificate_url, "_blank")
                setLoading(false);
            }
        }).catch(error => {
            CustomToast.error(error);
            setLoading(false);
        })
    }

    /*  const togglePlayPause = (courseId) => {
          const video = videoRefs.current[courseId];
          const playBtn = document.getElementById(`playBtn-${courseId}`);
  
          if (video) {
              if (video.paused) {
                  video.play();
                  setPlaying(true);
                  setShowOverlay(true);
              } else {
                  video.pause();
                  setPlaying(false);
                  setShowOverlay(false);
              }
          }
      }; */

    const getInitials = (name) => {
        return name?.split(' ').map(word => word.charAt(0)).join('').toUpperCase() || '';
    };

    const hindiMonths = [
        "जनवरी", "फरवरी", "मार्च", "अप्रैल", "मई", "जून",
        "जुलाई", "अगस्त", "सितंबर", "अक्टूबर", "नवंबर", "दिसंबर"
    ];

    const englishMonths = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];

    const formatDate = (expiry_date) => {
        var date = new Date(expiry_date);
        var day = date.getDate();
        var suffix = ["th", "st", "nd", "rd"];
        var daySuffix = (day % 10 <= 3 && (day < 11 || day > 13)) ? suffix[day % 10] : suffix[0];
        var month = i18n.language == 'hi' ? hindiMonths[date.getMonth()] : englishMonths[date.getMonth()];
        var year = date.getFullYear();
        return day + daySuffix + ' ' + month + ', ' + year;
    }

    return (
        <>
            <div className='learning_course'>
                {loader ? <Loader /> :
                    <> {courseList && courseList?.map((course, index) => {

                        const description = course?.description;
                        const courseId = course?.id;
                        const expiryDate = formatDate(course?.expiry_date);
                        const langId = getLangCode(courseList[index]?.lang);
                        const tForLang = i18n.getFixedT(langId);

                        return <div key={index} className="card shadow-custom" style={{ marginBottom: "20px", marginTop: "20px" }}>
                            <div className="card-body p-4">
                                <div className="course-header">
                                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                        <img
                                            src="/images/course_list.png"
                                            alt="course icon"
                                            style={{ width: "35px", height: "35px" }}
                                        />
                                        <h3 className="fw-bold text-capitalize font-20 mb-0">
                                            {tForLang('home_page_courses')} {index + 1}
                                        </h3>
                                    </div>
                                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                        <div style={{ width: "40px", height: "40px" }}>
                                            <CircularProgressbar
                                                value={course?.completion_percent}
                                                text={`${course?.completion_percent}%`}
                                                strokeWidth={10}
                                            />
                                        </div>
                                        <p style={{ margin: 0, fontWeight: 600, fontSize: "16px" }}>
                                            {course?.completion_percent === 100
                                                ? tForLang('home_page_completed')
                                                : course?.completion_percent === 0
                                                    ? tForLang('home_page_get_started')
                                                    : tForLang('home_page_in_progress')}
                                        </p>
                                    </div>
                                </div>
                                <hr></hr>
                                <div className='row'>
                                    <div className='col-md-3'>
                                        {course.video ? (
                                            <div className="course-container">
                                                <div className="listing learning_course_video">
                                                    <video
                                                        className="w-100"
                                                        style={{ width: "300px", height: "auto", objectFit: "fill", borderRadius: "18px" }}
                                                        poster={course?.image}
                                                    >
                                                        <source src={course?.video} type="video/mp4" />
                                                    </video>
                                                    <button id="playBtn" className="play-btn1" onClick={() => openModal(course?.video)}>
                                                        {/* SVG play icon */}
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 180 180" fill="none">
                                                            <g filter="url(#filter0_d_1545_54856)">
                                                                <path d="M77.4505 113.254V55.3722L116.038 84.3132M90.3132 20C81.8674 20 73.5044 21.6635 65.7016 24.8955C57.8987 28.1276 50.8089 32.8649 44.8369 38.8369C32.7758 50.8979 26 67.2563 26 84.3132C26 101.37 32.7758 117.728 44.8369 129.789C50.8089 135.761 57.8987 140.499 65.7016 143.731C73.5044 146.963 81.8674 148.626 90.3132 148.626C107.37 148.626 123.728 141.85 135.789 129.789C147.85 117.728 154.626 101.37 154.626 84.3132C154.626 75.8674 152.963 67.5044 149.731 59.7016C146.499 51.8987 141.761 44.8089 135.789 38.8369C129.817 32.8649 122.728 28.1276 114.925 24.8955C107.122 21.6635 98.7589 20 90.3132 20Z" fill="white"></path>
                                                            </g>
                                                            <defs>
                                                                <filter id="filter0_d_1545_54856" x="0.718277" y="0.0407453" width="179.19" height="179.19" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                                                                    <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
                                                                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix>
                                                                    <feOffset dy="5.32247"></feOffset>
                                                                    <feGaussianBlur stdDeviation="12.6409"></feGaussianBlur>
                                                                    <feComposite in2="hardAlpha" operator="out"></feComposite>
                                                                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"></feColorMatrix>
                                                                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1545_54856"></feBlend>
                                                                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1545_54856" result="shape"></feBlend>
                                                                </filter>
                                                            </defs>
                                                        </svg>
                                                    </button>
                                                </div>
                                            </div>
                                        ) : course.image ? (
                                            <img
                                                src={course.image}
                                                alt="course"
                                                style={{ width: "300px", height: "auto", objectFit: "fill", borderRadius: "30px" }}
                                                className="img-fluid w-100 card-img"
                                            />
                                        ) : (
                                            <img
                                                src="https://inclusional.s3.ap-south-1.amazonaws.com/project_live/images/2024-02-26 06:44:03-Safe Workplaces_Banner-03.png"
                                                alt="default course"
                                                style={{ width: "300px", height: "auto", objectFit: "fill", borderRadius: "30px" }}
                                                className="img-fluid w-100 card-img"
                                            />
                                        )}
                                    </div>
                                    <div className='col-md-6 mt-2'>
                                        <h3 className="fw-bold text-capitalize font-20 mt-2">{course?.course_name}</h3>
                                        <p className="text-gray font-16 mb-2">{course?.tagline}</p>
                                        <p className='mb-0'>
                                            <span className="text-dark-gray text-capitalize pe-4"><img src="/images/time.svg" className="me-2" />{course?.duration} </span>
                                            <span className="text-dark-gray text-capitalize"><img src="/images/modules.png" className="me-2" />{course?.total_modules} {tForLang('home_page_modules')}</span>
                                        </p>
                                        <div className='font-14 my-3 course-description'>
                                            {showFullDescription[courseId] ? (
                                                <div dangerouslySetInnerHTML={{ __html: description?.replace(/<p>(\s|&nbsp;)*<\/p>/g, '') }} />
                                            ) : (
                                                <div>
                                                    <div dangerouslySetInnerHTML={{ __html: description?.slice(0, 300).replace(/<p>(\s|&nbsp;)*<\/p>/g, '') }} />
                                                    {description?.length > 300 && (
                                                        <button
                                                            type="button"
                                                            className="btn btn-link px-0 text-decoration-none"
                                                            onClick={() => handleViewMore(courseId)}
                                                        >
                                                        </button>
                                                    )}
                                                </div>
                                            )}

                                            <div className="row mt-4">

                                                {/* Course Information Button */}
                                                {course?.status == 'notstarted' && (!fromCourseInfo || !languageSelected) ?
                                                    <div className="col-md-6">
                                                        <button type="button" className="btn btn-md btn-secondary w-100 mb-lg-0 mb-3" onClick={() => {openLanguageSelectModal(course, true); setHasClicked(true);}}> {tForLang('home_page_course_information')} </button>
                                                    </div>
                                                    :
                                                    <div className="col-md-6">
                                                        <button type="button" className="btn btn-md btn-secondary w-100 mb-lg-0 mb-3" onClick={() => {courseInformation(course); setHasClicked(true);}}>{tForLang('home_page_course_information')}</button>
                                                    </div>
                                                }

                                                {/* Get Started Button */}
                                                {course?.status == 'notstarted' && (!fromCourseInfo || !languageSelected) ?
                                                    <div className="col-md-6">
                                                        <button type="button" className="btn btn-md btn-primary disabled-btn w-100" disabled={course?.is_course_expired} onClick={() => openLanguageSelectModal(course, false)}>{tForLang('home_page_get_started')}</button>
                                                    </div>
                                                    : course?.status == 'notstarted' &&
                                                    <div className="col-md-6">
                                                        <button type="button" className="btn btn-md btn-primary disabled-btn w-100" disabled={course?.is_course_expired} onClick={() => startCourseList(course)}>{tForLang('home_page_get_started')}</button>
                                                    </div>
                                                }

                                                {course?.status == 'completed' &&
                                                    <div className="col-md-6">
                                                        <button type="button" className="btn btn-md btn-primary disabled-btn w-100" disabled={course?.is_course_expired} onClick={() => continuesCourse(course)}>{tForLang('home_page_completed')}</button>
                                                    </div>
                                                }

                                                {course?.status == 'inprogress' &&
                                                    <div className="col-md-6">
                                                        <button className="btn btn-md btn-primary disabled-btn w-100" disabled={course?.is_course_expired} onClick={() => continuesCourse(course)}>{tForLang('home_page_continue_course')}</button>
                                                    </div>
                                                }

                                            </div>
                                        </div>
                                        {course?.is_course_expired &&
                                            <div className='row'>
                                                <p className='font-14 my-3 course-description'> <strong>{tForLang('home_page_please_note')}</strong> {tForLang('home_page_expired_course_licence_error1', { expiryDate })} {tForLang('home_page_expired_course_licence_error2')}</p>
                                            </div>
                                        }
                                    </div>
                                    <div className='col-md-3 mt-0 mt-md-4'>
                                        <div className="p-3 border-bottom rounded-0 mb-0 mb-md-3">
                                            <div className="d-flex align-items-center">
                                                <img src="/images/certificate-download.svg" className="me-2" style={{ width: "24px", height: "24px" }} alt="Certificate" />
                                                {course?.status === 'completed' ? (
                                                    <p
                                                        style={{
                                                            cursor: "pointer",
                                                            // fontWeight: "bold",
                                                            // color: "#d9534f",
                                                            margin: 0,
                                                        }}
                                                        onClick={() => getCertificate(course)}
                                                    >
                                                        {tForLang('home_page_download_certificate')}
                                                    </p>
                                                ) : (
                                                    <p style={{ margin: 0, }}>
                                                        {tForLang('home_page_complete_the_course')}
                                                    </p>
                                                )}
                                            </div>
                                        </div>

                                        <div className="p-3 border-bottom rounded-0">
                                            {course?.total_completed_users == 0 &&
                                                course?.completion_percent != 100 &&
                                                (course?.status == "notstarted" || course?.status == "inprogress") ? (
                                                <div className="text-start">
                                                    <img
                                                        src="/images/account.svg"
                                                        className="mb-2"
                                                        style={{ height: "25px", width: "25px", borderRadius: "50%" }}
                                                        alt="Be the first"
                                                    />
                                                    <p>{tForLang('home_page_first_one_to_complete')}</p>
                                                </div>
                                            ): course?.completed_user_list?.length > 1 && course?.completed_user_list?.length <= 10 && course?.completion_percent == 100 && course?.status == "completed" ?
                                                    <div className="text-start ">
                                                        <div className='d-flex align-items-start ms-2'>
                                                            {course?.completed_user_list?.slice(0, 5).map((user, index) => {
                                                            return (
                                                                <span className="mb-2" key={index}>
                                                                    {user?.pic && user?.pic !== "null" && user?.pic !== null ? (
                                                                        <img src={user?.pic} className="mb-2 me-0" style={{ height: "28px", width: "28px", borderRadius: "50%" }} />
                                                                    ) : (
                                                                        <span className='course-card-initials fw-bolder font-28 mb-2 me-0 text-white'>{getInitials(user?.name)}</span>
                                                                    )}
                                                                </span>
                                                            );
                                                        })}
                                                            {course?.total_completed_users > 5 && (
                                                                <span className="mb-2 count-circle">
                                                                    {course?.total_completed_users - 1}+
                                                                </span>
                                                            )}
                                                        </div>
                                                        <p className="mb-0">{tForLang('home_page_congrates')}</p>
                                                        {/* <p>You are among the top 10 <span>{course?.completed_user_list?.length > 0 && course?.completed_user_list?.length !== 1 ? 'employees' : 'employee'}</span> to complete the course</p> */}
                                                    </div> : course?.completed_user_list?.length === 1 && course?.completion_percent == 100 && course?.status == "completed" ?
                                                        <div className="text-start ">
                                                            <div className='d-flex align-items-start ms-2'>
                                                               {course?.completed_user_list?.slice(0, 5).map((user, index) => {
                                                            return (
                                                                <span className="mb-2" key={index}>
                                                                    {user?.pic && user?.pic !== "null" && user?.pic !== null ? (
                                                                        <img src={user?.pic} className="mb-2 me-0" style={{ height: "28px", width: "28px", borderRadius: "50%" }} />
                                                                    ) : (
                                                                        <span className='course-card-initials fw-bolder font-28 mb-2 me-0 text-white'>{getInitials(user?.name)}</span>
                                                                    )}
                                                                </span>
                                                            );
                                                        })}
                                                                {course?.total_completed_users > 5 && (
                                                                    <span className="mb-2 count-circle">
                                                                        {course?.total_completed_users - 1}+
                                                                    </span>
                                                                )}
                                                            </div>
                                                            <p className="mb-0">{tForLang('home_page_you_are_first_one_to_complete')}</p>
                                                            {/* <p>You are among the top 10 <span>{course?.completed_user_list?.length > 0 && course?.completed_user_list?.length !== 1 ? 'employees' : 'employee'}</span> to complete the course</p> */}
                                                        </div> :
                                                        <div className="text-start ">
                                                            <div className='d-flex align-items-start ms-2'>
                                                                 {course?.completed_user_list?.slice(0, 5).map((user, index) => {
                                                            return (
                                                                <span className="mb-2" key={index}>
                                                                    {user?.pic && user?.pic !== "null" && user?.pic !== null ? (
                                                                        <img src={user?.pic} className="mb-2 me-0" style={{ height: "28px", width: "28px", borderRadius: "50%" }} />
                                                                    ) : (
                                                                        <span className='course-card-initials fw-bolder font-28 mb-2 me-0 text-white'>{getInitials(user?.name)}</span>
                                                                    )}
                                                                </span>
                                                            );
                                                        })}
                                                                {course?.total_completed_users > 5 && (
                                                                    <span className="mb-2 count-circle">
                                                                        {course?.total_completed_users - 1}+
                                                                    </span>
                                                                )}
                                                            </div>

                                                            <p className='mb-0'>{course?.total_completed_users} <span>{course?.completed_user_list?.length > 0 && course?.completed_user_list?.length !== 1 ? tForLang('home_page_employees') : tForLang('home_page_employee')}</span> {tForLang('home_page_employees_completed_course')}</p>
                                                        </div>
                                            }
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    })} </>
                }
                <Modal
                    isOpen={isOpenLangModal}
                    contentLabel="Active Modal"
                >
                    <LanguageSelectModal
                        isOpen={isOpenLangModal}
                        onRequestClose={closeLanguageSelectModal}
                        course={currentCourse}
                        onConfirm={getCourseSelectedLang}
                    />
                </Modal>
                <Modal
                    isOpen={isOpenGenModal}
                    contentLabel="Active Modal"
                    className="w-50 bg-white"
                >
                    <GeneralModal
                        isOpen={isOpenGenModal}
                        message={popUpMessage}
                        onRequestClose={closeGeneModal}
                    />
                </Modal>
            </div>
        </>
    )

}

export default Course;